// Odia + English WhatsApp message templates for the Refer & Earn feature.
// The share link is dynamically injected. The template can be overridden by
// the admin campaign config (share_message with a `{link}` placeholder);
// when no template is provided the default Odia copy below is used.
const DEFAULT_TEMPLATE = `🚨🔥 *PM POSHAN / MDM କାମ କରୁଥିବା TEACHERମାନଙ୍କ ପାଇଁ ଖାସ!* 🍚📊

😫 *MDM Calculation, Rice, Cooking Cost, Daily Entry ଓ Report ପାଇଁ ଏତେ ସମୟ କାହିଁକି?*

🧮 MDM Calculation
🍚 Rice Calculation
💰 Cooking Cost
📝 Daily Entry
📊 MDM Reports
📄 MDCF / UC

🚀 *PM POSHAN କାମକୁ ଆହୁରି ସହଜ ଓ ସୁସଂଗଠିତ କରନ୍ତୁ!*

🎁 *ମୋର Referral Link ରୁ JOIN କରନ୍ତୁ:*

👇👇👇
🔗 {link}

💚 *ଥରେ OPEN କରି ଦେଖନ୍ତୁ!* 🚀`;

export function referralWhatsappMessage(shareLink, template) {
  const t = (template && typeof template === "string" && template.includes("{link}")) ? template : DEFAULT_TEMPLATE;
  return t.replaceAll("{link}", shareLink);
}
